module.exports = __webpack_public_path__ + "img/red-desert-decal-11.8f18db34.png";